<template>
  <div class="f-center l-section--padding" >
    <Icon :icon="icon" class="o-icon--inline" :font-size="fontSizeValue" />
    <h1 class="f-h1 h-marginBottom--10" :class="{'text-red font-bold':color==='red'}" v-html="title"></h1>
    <hr class="o-hr mb-[0px]" :class="{'!mb-[10px]':text}"  />
    <p v-if="text" class="f-b4 h-marginBottom--0" style="padding: 0 20px; line-height: 1.2" v-html="text"></p>
  </div>
</template>

<script>

import Icon from "@/components/App/Icon"
import config from "@/config"

export default {
  name: 'PageIntro',
  props:['title','icon','fontSize',"hText",'color'],
  components:{
    Icon
  },
  computed:{
    text(){
      return (this.hText)?this.hText:config.getConfig('app.pageIntroText',this.title);
    },
    fontSizeValue(){
      return (this.fontSize)?this.fontSize:36;
    }
  }
}

</script>
